// API
export var LOGOUT_URL = '/api/logout';
export var VCODE_STRING = 'vcode';